var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: _vm.popTitle,
            width: "950px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm9",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "添加图片:", prop: "bannerPic" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "relative",
                            width: "130px",
                            height: "130px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                "on-success": _vm.handleAvatarSuccess,
                                action: "",
                                "http-request": _vm.handleFileUpload,
                              },
                            },
                            [
                              _vm.ruleForm.bannerPic
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.bannerPic,
                                      fit: "contain",
                                    },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                              _vm._v(" "),
                              _vm.ruleForm.bannerPic
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        _vm.ruleForm.bannerPic = ""
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.componentCode === "topSearch"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                "高度116，宽度自定义，PNG格式图片 (可参考默认的占位图)"
                              ),
                            ]
                          )
                        : _vm.componentCode === "banner"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                "图片尺寸" +
                                  _vm._s(
                                    _vm.componentSubcode === "ba_b"
                                      ? "750*270"
                                      : "750*180"
                                  )
                              ),
                            ]
                          )
                        : _vm.componentCode === "slidingCapsule"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("高度120，宽度自定义，PNG格式图片")]
                          )
                        : _vm.componentCode === "diamond"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("图片尺寸128*128")]
                          )
                        : _vm.componentCode === "freePuzzle"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                "总宽度750，单块拼图宽度按模块数量均分，高度自定义(可参考默认的占位图)"
                              ),
                            ]
                          )
                        : _vm.componentCode === "bottomShopList"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("建议图片宽度702, 高度自定义，PNG格式")]
                          )
                        : _vm.componentCode === "bannerWithPuzzle"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  !_vm.myKey
                                    ? "图片尺寸750*233"
                                    : "图片尺寸343*152"
                                )
                              ),
                            ]
                          )
                        : _vm.componentCode === "verticalBannerWithPuzzle"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm.componentSubcode === "v_ba_p_2" ||
                              _vm.componentSubcode === "v_ba_p_5"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.myKey
                                          ? "图片尺寸365*504"
                                          : "图片尺寸365*242"
                                      )
                                    ),
                                  ])
                                : _vm.componentSubcode === "v_ba_p_3"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.myKey
                                          ? "图尺寸365*504"
                                          : _vm.tipIndex === 0
                                          ? "图片尺寸365*242"
                                          : "图片尺寸172*242"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm.componentCode === "toolbar"
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("图标尺寸：120*120 px，PNG 格式")]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.componentCode != "bottomShopList"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "名称:", prop: "bannerName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入名称" },
                            model: {
                              value: _vm.ruleForm.bannerName,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "bannerName", $$v)
                              },
                              expression: "ruleForm.bannerName",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.componentCode === "toolbar"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "底部说明:", prop: "bottomDesc" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.ruleForm.bottomDesc,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "bottomDesc", $$v)
                              },
                              expression: "ruleForm.bottomDesc",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.componentCode != "bottomShopList"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "排序:", prop: "sort" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "number",
                              placeholder: "请输入排序数字",
                            },
                            model: {
                              value: _vm.ruleForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "sort", $$v)
                              },
                              expression: "ruleForm.sort",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否启用:", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.ruleForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "status", $$v)
                            },
                            expression: "ruleForm.status",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.componentCode === "diamond" &&
                  _vm.componentSubcode === "s_a_c"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "是否显示角标", prop: "cornerMark" },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.cornerMark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "cornerMark", $$v)
                                },
                                expression: "ruleForm.cornerMark",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.cornerMark === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "角标图片:", prop: "cornerMarkPic" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "relative",
                                width: "130px",
                                height: "130px",
                                background: "#f9f9f9",
                                "border-radius": "4px",
                                border: "1px solid #eeeeee",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    "show-file-list": false,
                                    action: "",
                                    "http-request": _vm.handleFileUpload1,
                                  },
                                },
                                [
                                  _vm.ruleForm.cornerMarkPic
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "130px",
                                          height: "130px",
                                        },
                                        attrs: {
                                          src: _vm.ruleForm.cornerMarkPic,
                                          fit: "contain",
                                        },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                  _vm._v(" "),
                                  _vm.ruleForm.cornerMarkPic
                                    ? _c("i", {
                                        staticClass: "el-icon-error",
                                        staticStyle: {
                                          position: "absolute",
                                          right: "-30px",
                                          top: "-10px",
                                          "font-size": "25px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.ruleForm.cornerMarkPic = ""
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.componentCode === "diamond"
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#969696",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v("图片尺寸111*69")]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.componentCode === "bannerWithPuzzle" && !_vm.myKey
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "拼图背景色",
                            prop: "backgroundColorType",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.ruleForm.backgroundColorType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "backgroundColorType",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.backgroundColorType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("渐变背景"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("纯色背景"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("渐变背景默认自上而下渐变")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.backgroundColorType === 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "起始色：", prop: "startColor" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.ruleForm.startColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "startColor", $$v)
                                  },
                                  expression: "ruleForm.startColor",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-color-picker", {
                                model: {
                                  value: _vm.ruleForm.startColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "startColor", $$v)
                                  },
                                  expression: "ruleForm.startColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.backgroundColorType === 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "结束色：", prop: "endColor" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.ruleForm.endColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "endColor", $$v)
                                  },
                                  expression: "ruleForm.endColor",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-color-picker", {
                                model: {
                                  value: _vm.ruleForm.endColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "endColor", $$v)
                                  },
                                  expression: "ruleForm.endColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.backgroundColorType === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "背景色：", prop: "backgroundColor" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.ruleForm.backgroundColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "backgroundColor",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.backgroundColor",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-color-picker", {
                                model: {
                                  value: _vm.ruleForm.backgroundColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "backgroundColor",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.backgroundColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.componentCode === "toolbar"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "展示权限:",
                            prop: "displayPermission",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.ruleForm.displayPermission,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "displayPermission",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.displayPermission",
                              },
                            },
                            _vm._l(_vm.displayOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#969696",
                                "font-size": "12px",
                                "line-height": "18px",
                                display: "inline-block",
                              },
                            },
                            [
                              _vm._v("配置功能展示范围(默认所有人)"),
                              _c("br"),
                              _vm._v(
                                "注意:“我的粉丝”“修改邀请码”“推荐人”“补填邀请码”“粉丝收益榜”不建议对自购用户开放"
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动跳转:", prop: "jumpType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.jumpType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "jumpType", $$v)
                            },
                            expression: "ruleForm.jumpType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("选择活动"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("url跳转"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "活动选择:" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.goAct()
                                },
                              },
                            },
                            [_vm._v("去选择")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 2
                    ? _c("el-form-item", { attrs: { label: "" } }, [
                        _vm.ruleForm.activityTypeName &&
                        _vm.ruleForm.activityName
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "background-color": "#f8f8f8",
                                  padding: "10px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { width: "80px" } },
                                      [_vm._v("活动类型:")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { readonly: true },
                                      model: {
                                        value: _vm.ruleForm.activityTypeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "activityTypeName",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.activityTypeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start",
                                      "align-items": "center",
                                      margin: "5px 0",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { width: "80px" } },
                                      [_vm._v("活动名称:")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { readonly: true },
                                      model: {
                                        value: _vm.ruleForm.activityName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "activityName",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.activityName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "跳转链接:", prop: "openUrl" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入跳转链接" },
                            model: {
                              value: _vm.ruleForm.openUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "openUrl", $$v)
                              },
                              expression: "ruleForm.openUrl",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间设置:", prop: "timeArray" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          type: "datetimerange",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        model: {
                          value: _vm.timeArray,
                          callback: function ($$v) {
                            _vm.timeArray = $$v
                          },
                          expression: "timeArray",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#F59A23",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            "请选择活动时间（未选择时间时默认为长期有效状态）"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-top": "60px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm9")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm9")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("ActivitySelectionPopup", {
        ref: "activitySelectionPopup",
        on: { SelectEvents: _vm.onSelectEvents },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }